import React, { useEffect, useState } from 'react';
import LoadingScreen from '@components/LoadingScreen/LoadingScreen';
import AlertToast from '@components/AlertToast/AlertToast';
import { useAppContext } from '@context/AppContext';
import moment from 'moment';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import Badge from '@components/Badge/Badge';
import styles from './TableReportAutorization.module.scss';

interface TableReportAutorizationProps {
    data: any[];
}

const TableReportAutorization: React.FC<TableReportAutorizationProps> = ({
        data ,
    }) => {
    const { state } = useAppContext();
    const [loadingState, setLoadingState] = useState(false);
    const [loadingMessage, setLoadingMessage] = useState('');
    const [alertToastMessage, setAlertToastMessage] = useState('');
    const [alertToastState , setAlertToastState] = useState(false);
    const [alertToastIcon, setAlertToastIcon] = useState<'success' | 'error' | 'warning' | 'info'>('success');
   
    return (
        <>
            {loadingState && <LoadingScreen message={loadingMessage} />}
            { alertToastState && (
                <AlertToast icon={alertToastIcon} title={alertToastMessage} closeAlert={() => setAlertToastState(false)} />
            )}
            <div className={styles.tableBox}>
                <div className={styles['tableBox-table']}>
                    <div className={`${styles['tableBox-table-row']} ${styles.header}`}>
                        <div className={styles['tableBox-table-header']}>
                            <div className={styles['tableBox-table-header-text']}>
                                Nombre Paciente
                            </div>
                        </div>
                        <div className={styles['tableBox-table-header']}>
                            <div className={styles['tableBox-table-header-text']}>
                                Preparado
                            </div>
                        </div>
                        <div className={styles['tableBox-table-header']}>
                            <div className={styles['tableBox-table-header-text']}>
                                Dosis
                            </div>
                        </div>
                        <div className={styles['tableBox-table-header']}>
                            <div className={styles['tableBox-table-header-text']}>
                                Vol Vehículo
                            </div>
                        </div>
                        <div className={styles['tableBox-table-header']}>
                            <div className={styles['tableBox-table-header-text']}>
                                Institución
                            </div>
                        </div>
                        <div className={styles['tableBox-table-header']}>
                            <div className={styles['tableBox-table-header-text']}>
                                Origen droga
                            </div>
                        </div>
                        <div className={styles['tableBox-table-header']}>
                            <div className={styles['tableBox-table-header-text']}>
                                Administración
                            </div>
                        </div>
                        <div className={styles['tableBox-table-header']}>
                            <div className={styles['tableBox-table-header-text']}>
                                Envío a elaboración
                            </div>
                        </div>
                        <div className={styles['tableBox-table-header']}>
                            <div className={styles['tableBox-table-header-text']}>
                                Estado
                            </div>
                        </div>
                    </div>
                    {data.map((item, index) => (
                        <div className={styles['tableBox-table-contentRow']} key={item._id ?? `row-${index}`}>
                            <div className={ styles['tableBox-table-row'] }>
                                <div className={styles['tableBox-table-body']}>{item.patient.fullName || ''}</div>
                                <div className={styles['tableBox-table-body']}>{item.medications.drugName}</div>
                                <div className={styles['tableBox-table-body']}>{ `${item.medications.dose} mg` || ''}</div>
                                <div className={styles['tableBox-table-body']}>{item.medications.solutionName} {item.medications.solutionVolume}</div>
                                <div className={styles['tableBox-table-body']}>{item.organizationName}</div>
                                <div className={styles['tableBox-table-body']}>{item.medications.originDrugSelected ? item.medications.originDrugSelected.name : ''}</div>
                                <div className={styles['tableBox-table-body']}>{item.medications.administrationDate ? moment.utc(item.medications.administrationDate).format('DD/MM/yyyy') : ''}</div>
                                <div className={styles['tableBox-table-body']}>{ item.pickingDate ? moment.utc(item.pickingDate).format('DD/MM/yyyy HH:mm') : '' }</div>
                                <div className={styles['tableBox-table-body']}>
                                    <Badge text={item.status} state={item.status} />
                                    <OverlayTrigger placement="left" overlay={<Tooltip className='tapps-tooltip'>Esto corresponde al área de compounding donde se encuentra la solicitud</Tooltip>}>
                                        <div className={styles.withPopover}>
                                            <i className="iconwhite-information3"></i> { item.currentStageName }
                                        </div>
                                    </OverlayTrigger>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </>
    );
};

export default TableReportAutorization;
